import axios from "@/plugins/axios";

let url = "/api/console/notification-logs";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    }
}
